// extracted by mini-css-extract-plugin
module.exports = {"beforeTablePdf":"Table_beforeTablePdf__BXLaM","pdf":"Table_pdf__lipKv"};